module.exports = __webpack_public_path__ + "img/roof-repair-exterior-maintenance-06.56fc8312.jpg";